export enum FontSize {
  font10 = '10px',
  font12 = '12px',
  font14 = '14px',
  font16 = '16px',
  font18 = '18px',
  font20 = '20px',
  font24 = '24px',
  font36 = '36px',
  font60 = '60px',
}

export enum FontWeight {
  light = '300',
  regular = '400',
  medium = '500',
  semiBold = '600',
  bold = '700',
  xBold = '900',
}
